import BaseClass from "../../../util/BaseClass";
import Context from "../../../context/Context";
import OfficePlan from "../OfficePlan";
import Rdx from "../../../redux/Rdx";
import Topic from "../../../context/Topic";
import TransactionGuard from "../TransactionGuard";
import * as serviceUtil from "../serviceUtil";
import * as sourceUtil from "../sourceUtil";
import * as val from "../../../util/val";

/*
  https://developer.myscript.com/docs/interactive-ink/1.3/android/advanced/combined-undo-redo-stacks
*/

export default class UndoManager extends BaseClass {

  _locked = false;
  _lockedAdds;

  _stack;
  _stackPosition;

  constructor(props) {
    super(props);
    this._stack = [];
    this._stackPosition = -1;
  }

  addTransaction(transaction) {
    if (!this._locked) {
      this._stack.splice(this._stackPosition + 1); // remove the redo transactions from the stack
      this._stack.push(transaction);
      this._stackPosition = (this._stack.length - 1);
      this._updateStatus();
    } else {
      this._lockedAdds.push(transaction);
    }
  }

  _apply(undoTransaction,method) {
    const guard = new TransactionGuard({force: true});
    let transaction = undoTransaction;
    if (method === "redo") transaction = transaction.redoTransaction;
    console.log("UndoManager.applyTransaction",transaction);
    const reqInfo = transaction.requestInfo;
    const reqUrl = reqInfo.requestUrl;
    const reqOpts = reqInfo.requestOptions;
    const esriRequest = Context.instance.lib.esri.esriRequest;
    console.log("applyEdits.reqInfo",reqInfo)
    esriRequest(reqUrl,reqOpts).then(result => {
      console.log("UndoManager.applyEdits.result",result);
      serviceUtil.validateApplyEditsResponse(result);
      const results = (result && result.data);

      // TODO check result for errors?
      // result.data is an array of {id: layerId, updateResults: []}

      if (transaction.afterApplyEdits) {
        transaction.afterApplyEdits(results,undoTransaction,method);
      }

      try {
        if (transaction.hadPeopleEdits) {
          sourceUtil.getPeopleLayer().refresh();
        }
        if (transaction.hadUnitEdits) {
          sourceUtil.getUnitsLayer().refresh();
        }
      } catch(ex)  {
        console.error(ex);
      }
      if (transaction.hadAreasTableEdits) {
        const areasTable = OfficePlan.getActive().areasTable;
        if (areasTable && areasTable.table) {
          return OfficePlan.getActive().areasTable._refresh();
        }
      }
    }).then(() => {
    }).then(() => {
      guard.close();
      Topic.publish(Topic.PlanModified, {
        action: OfficePlan.Action_AssignmentsUpdated,
      });
      this._unlock(method);
    }).catch((error) => {
      guard.close();
      console.error("Error applying edits", error);
      Topic.publishErrorUpdatingData(error.submessage);
      this._unlock(); // TODO???
    });
  }

  clear() {
    this._stack = [];
    this._stackPosition = -1;
    this._locked = false;
    this._lockedAdds = [];
    this._updateStatus();
  }

  _lock() {
    if (this._locked) return;
    this._locked = true;
    this._lockedAdds = [];
    this._updateStatus();
  }

  makeTransaction(props) {
    const transaction = {
      id: val.generateRandomUuid(),
      wasCompleted: false,
      failed: false,
      hadPeopleEdits: false,
      hadUnitEdits: false,
      hadAreasTableEdits: false,
      requestInfo: null,
      redoTransaction: null
    };
    if (props) {
      Object.assign(transaction,props);
    }
    return transaction;
  }

  redo() {
    if (this._locked) return;
    this._lock();
    let transaction = this._stack[this._stackPosition + 1];
    if (transaction && transaction.redoTransaction) {
      this._apply(transaction,"redo");
    } else {
      this._unlock();
    }
  }

  undo() {
    if (this._locked) return;
    this._lock();
    const transaction = this._stack[this._stackPosition];
    if (transaction) {
      this._apply(transaction,"undo");
    } else {
      this._unlock();
    }
  }

  _unlock(methodApplied) {
    if (!this._locked) return;
    if (this._lockedAdds.length > 0) {
      this._stack.splice(this._stackPosition + 1); // remove the redo transactions from the stack
      this._lockedAdds.forEach(transaction => {
        this._stack.push(transaction);
        this._stackPosition = (this._stack.length - 1);
      })
    } else if (methodApplied === "undo") {
      this._stackPosition = (this._stackPosition - 1);
    } else if (methodApplied === "redo") {
      this._stackPosition = (this._stackPosition + 1);
    }
    this._locked = false;
    this._lockedAdds = [];
    this._updateStatus();
  }

  _updateStatus() {
    console.log("UndoManager._updateStatus",this._locked,this._stackPosition,this._stack)
    let canUndo = false;
    let canRedo = false;
    if (!this._locked) {
      let pos = this._stackPosition;
      let len = this._stack.length;
      canUndo = (len > 0 && pos >= 0);
      canRedo = (len > 0 && (pos < (len - 1)));
    }
    Rdx.setValue(null,Rdx.Keys.PLAN_CAN_UNDO,canUndo);
    Rdx.setValue(null,Rdx.Keys.PLAN_CAN_REDO,canRedo);
  }

}
